import { HttpClient } from  '@angular/common/http';
import {Injectable} from "@angular/core";
import {Observable, of} from "rxjs/index";
import {BusinessType} from "../../../model/business/business-type.model";
import {Business} from "../../../model/business/business.model";
import {MenuItemDto} from "../../../model/menu/dto/menu-item-dto.model";
import {environment} from "../../../../environments/environment";
import {AuthHttp} from "angular2-jwt";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class OrderHistoryService {

  public readonly PRODUCT_NAMES = [
    'Burger',
    'Omleta taraneasca',
    'Sarmale in foi de vita',
    'Coca cola',
    'Apa plata 0.5L',
    'Fanta',
    'Bruschette',
    'Pizza cu sunca - mare',
    'Mamaliga cu branza (MBS)'
  ];

  public readonly COMMAND_STATUS = [
    "ACCEPTED",
    "IN_PROGRESS",
    "DONE",
    "REJECTED",
    "AWAITING_PAYMENT"
  ];

  public readonly PRODUCT_COMMENTS = [
    "Cu mai multa sare",
    "Si o portie de paine prajita",
    "Fara mozzarella",
    "Cu ou si cu otet",
    "",
    "",
    ""
  ];

  constructor(private authHttp: AuthHttp,
              private httpClient: HttpClient,
              private translate: TranslateService) {

  }

  public getOrderHistory(businessId: string, startDateIso: string, endDateIso: string): Observable<any> {
    return this.authHttp.get(environment.BACKEND_ROOT_SERVICE + "order-history/" + businessId
      + "/" + startDateIso + "/" + endDateIso);
  }

  public getMockCommandHistory() {
    const commandHistoryList = [];
    for (let i = 1; i <= 100; i++) {
      const commandDate = new Date();
      commandDate.setDate(commandDate.getDate() - i);
      const orderStatus = this.COMMAND_STATUS[Math.floor(Math.random() * 5)];
      commandHistoryList.push(this.createCommand(
        commandDate,
        '00000' + i,
        100 + (Math.floor(Math.random() * 90)),
        this.translate.instant('page.dashboard.analytics.orderHistory.status.' + orderStatus),
        orderStatus,
        '00' + i,
        'user' + i + '@gmail.com',
        this.createMockOrderedItems(Math.floor(Math.random() * 10))
        ));
    }
    return commandHistoryList;
  }

  private createMockOrderedItems(totalItems: number) {
    const orderedItemsList = [];
    for (let i = 0; i < totalItems; i++) {
      orderedItemsList.push(this.createOrderedItem(
        this.PRODUCT_NAMES[Math.floor(Math.random() * 9)],
        100 - (Math.floor(Math.random() * 90)),
        10 - (Math.floor(Math.random() * 10)),
        this.PRODUCT_COMMENTS[Math.floor(Math.random() * 7)]
      ));
    }
    return orderedItemsList;
  }

  private createCommand(datePlaced: Date, receiptNo: string, totalPrice: number, translatedStatus: string, orderStatus: string,
                        tableLabel: string, customerEmail: string, orderItems: any[]) {
    return {
      datePlaced,
      receiptNo,
      totalPrice,
      translatedStatus,
      orderStatus,
      tableLabel,
      customerEmail,
      orderItems
    };
  }

  private createOrderedItem(name: string, price: number, quantity: number, comments: string) {
    return {
      menuItem: new MenuItemDto(name, price, 'RON'),
      quantity,
      comments
    }
  }

}

